import React from "react";
import { Box, Typography } from "@mui/material";
import { BATTING_HOLES } from "../../constants/fanPage";
import { colors } from "../../theme";
import BattingOrderRow from "./BattingOrderRow";

const BattingOrderCard = ({
  battingOrder = {},
  editable = false,
  onSelect,
  onClear,
  onMove,
  compact = false,
}) => (
  <Box>
    <Typography
      variant="overline"
      color="text.secondary"
      sx={{ letterSpacing: "0.16em" }}
    >
      The order
    </Typography>
    <Typography variant="h5" fontWeight={800} sx={{ mt: 0.25 }}>
      Batting order
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2, maxWidth: 520 }}>
      {editable
        ? "Who you’d send to the plate. Tap a hole, or nudge someone up and down."
        : "Who they’d send to the plate."}
    </Typography>
    <Box
      sx={{
        borderRadius: 3,
        border: `1px solid ${colors.border}`,
        bgcolor: "#10140f",
        overflow: "hidden",
      }}
    >
      {BATTING_HOLES.map((hole, index) => (
        <BattingOrderRow
          key={hole.id}
          hole={hole}
          player={battingOrder[hole.id]}
          editable={editable}
          compact={compact}
          isFirst={index === 0}
          isLast={index === BATTING_HOLES.length - 1}
          onSelect={onSelect}
          onClear={onClear}
          onMove={onMove}
        />
      ))}
    </Box>
  </Box>
);

export default BattingOrderCard;
